/* eslint-disable */
import { withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';
import format from 'date-fns/format';
import isToday from 'date-fns/is_today';
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import i18nLocaleSelector from '../../State/Store/I18n/Selectors/I18nLocale.selector';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import I18n from '../I18n/I18n.component';
import './DateText.component.i18n';
import DateTextPropTypes from './DateText.component.props';
import dateTextStyles from './DateText.component.styles';

/**
 * DateTextComponent
 * @export
 * @class DateTextComponent
 * @extends {React.Component<DateTextComponentComposedProps, DateTextComponentState>}
 */
export class DateTextComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. NOT a `null` value
   * @static
   * @type {Partial<DateTextComponentProps>}
   * @memberof DateTextComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`DateText`}
   * @memberof DateTextComponent
   */
  static displayName = `DateText`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof DateTextComponent
   */
  static propTypes = DateTextPropTypes;

  /**
   * Data specific to the `<DateTextComponent />` instance
   * @type {DateTextComponentState}
   * @memberof DateTextComponent
   */
  state = {};

  /**
   * Render the component
   * @returns {React.Component} The rendered `<DateTextComponent />`
   * @memberof DateTextComponent
   */
  render() {
    const {
      classes,
      date,
      locale: { lang },
      width,
    } = this.props;
    const localeDate = format(date, `ddd D MMM`, { locale: lang });
    const isDateToday = isToday(date);
    return (
      <Grid alignItems="center" container className={classes.subheaderContainer}>
        <Typography gutterBottom noWrap variant="h6">
          {localeDate}
        </Typography>
        {isDateToday && !isWidthDown(`sm`, width) && (
          <I18n className={classes.todayLabel} gutterBottom variant="h6">
            DateText.Today
          </I18n>
        )}
      </Grid>
    );
  }
}

/** @type {React.ComponentClass<DateTextComponentProps>} */
const DateText = compose(
  withWidth(),
  withStyles(themeCreateInjectableStyles(dateTextStyles), { withTheme: true }),
  connect((state) => ({
    locale: i18nLocaleSelector(state),
  })),
)(DateTextComponent);

export default DateText;
